export const objectKeys = <T extends object>(obj: T) => {
  return Object.keys(obj) as Array<keyof T>;
};

export const enumIncludes = <T extends {}>(obj: T, key: string) => {
  return Object.values(obj).includes(key);
};

export const reduceDataByKey = (
  keys: string[],
  getValue: (key: string, i: number) => any
) => {
  return keys.reduce((accumulator, currentValue: string, i: number) => {
    return {
      ...accumulator,
      ...getValue(currentValue, i),
    };
  }, {});
};

export const orderByKey = <T extends { [key in string]: any }>(data: T) =>
  Object.keys(data)
    .sort()
    .reduce((obj: any, key: string) => {
      obj[key] = data[key];
      return obj;
    }, {});

export const removeDuplicatesByKey = (arr: Array<any>, key: string) =>
  arr.reduce((accumulator, current) => {
    let exists = accumulator.find((item: any) => item[key] === current[key]);
    if (!exists) accumulator = accumulator.concat(current);
    return accumulator;
  }, []);
